import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { hueSSOkey } from '../util/global';
import { qsData, request } from '../service/api/common';
import { SelectProps } from './_interface';
import { useTranslation } from 'react-i18next';
import useAlert from '../hooks/useAlert';
import { useRecoilState, useRecoilValue } from 'recoil';
import { loaderState, siteListState } from '../store/Atoms';
import { LoginStyle } from './_style';
import Input from '../components/atoms/Input';
import IcoInputSearch from '../assets/images/ico-input-search.svg';
import { DashboardStyle, TableListStyle } from '../components/templates/_style';
import { TableStyle } from '../components/atoms/_style';
import Table from '../components/atoms/Table';

const HUE_URL = {
  GET_D2_TOKEN: '/api/auth/v1/login/sso',
};

const VnSso = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { i18n, t } = useTranslation();
  const [, setLoading] = useRecoilState(loaderState);
  const [siteList, setSiteList] = useRecoilState(siteListState);
  const [word, setWord] = useState('');
  const [saveToken, setSaveToken] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const filteredSiteList = siteList.filter((i) => i.text.includes(word) || i.ownerCompany?.includes(word));

  /** sso 로그인 후 돌아와 토큰 취득*/
  const getToken = async () => {
    const { data } = await axios.post(
      HUE_URL.GET_D2_TOKEN,
      {
        code: searchParams.get('code')!,
      },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    );
    return data;
  };

  //현장 선택 후 대시보드 이동
  const onMoveDashboard = () => {
    sessionStorage.setItem('token', saveToken);
    window.location.href = '/dashboard';
  };

  //사업장 변경
  const onChangeSite = (id) => {
    setSiteList((prev) => {
      const newArr: SelectProps[] = [];
      prev.map((i) => {
        newArr.push({ ...i, active: id === i.value });
      });

      sessionStorage.setItem('siteId', String(newArr.find((i) => i.value === id)?.value));
      sessionStorage.setItem('projection', String(newArr.find((i) => i.value === id)?.projection));
      return newArr;
    });
  };

  useEffect(() => {
    setLoading({ show: true });
    if (!!searchParams.get('session_state')) {
      getToken()
        .then((data) => {
          const token = data.data.accessToken;
          console.log(data);
          sessionStorage.setItem('token', token);
          setSaveToken(token);
          request('auth')
            .get('v1/member', {
              headers: {
                'Content-Type': 'application/json',
                Authorization: token,
              },
            })
            .then(({ data }) => {
              setIsSuccess(true);
              if (data.data.country === 'VN') {
                i18n.changeLanguage('vn');
              } else if (data.data.country === 'ID') {
                i18n.changeLanguage('id');
              } else if (data.data.country === 'US') {
                i18n.changeLanguage('en');
              }

              sessionStorage.setItem('auth', data.data.auth);
              sessionStorage.setItem('loginId', data.data.loginId);

              if (data.data.auth !== 'ROLE_MASTER') {
                sessionStorage.setItem('solution', data.data.solutions);

                if (data.data.siteInfo.length) {
                  const newArr: SelectProps[] = [];
                  data.data.siteInfo.map((i, index) => {
                    newArr.push({ text: i.siteName, value: i.siteId, active: index === 0, facilityKinds: i.facilityKinds, ownerCompany: i.ownerCompany, projection: i.projection });
                  });

                  sessionStorage.setItem('siteId', String(newArr[0].value));
                  sessionStorage.setItem('projection', String(newArr[0].projection));
                  setSiteList(newArr);
                } else {
                  sessionStorage.setItem('token', token);
                  //  window.location.href = '/workplace/register';
                }
              } else {
                window.location.href = '/auth/list';
                sessionStorage.setItem('token', token);
              }
            })
            .catch((e) => {
              console.log(e);
              alert('Could not retrieve user information');
            });

          setLoading({ show: false });
        })
        .catch((e) => {
          alert(e.response?.data?.error);
          setLoading({ show: false });
        });
    }
  }, []);

  return (
    <>
      {isSuccess ? (
        <LoginStyle.Wrap>
          {/* 로그인 */}

          <LoginStyle.SiteTitle>{t('사업장을선택해주세요')}</LoginStyle.SiteTitle>
          <Input
            width={512}
            placeholder={t('사업장,발주처조회')}
            bg={IcoInputSearch}
            onChange={(e) => {
              setWord(e.target.value);
            }}
            isLogin={true}
          />

          <DashboardStyle.DescArea isLogin={true} style={{ zIndex: 1, flex: 'none', marginTop: 8 }}>
            <TableStyle.Wrap>
              <TableListStyle.Cont>
                {siteList.length ? (
                  <Table
                    type={2}
                    width={512}
                    height={'323px'}
                    tbodyHeight={252}
                    tbodyId={'tbody'}
                    colgroup={['50%', 'auto']}
                    isLogin={true}
                    thead={
                      <tr>
                        <th scope={'col'}>{t('사업장')}</th>
                        <th scope={'col'}>{t('발주처')}</th>
                      </tr>
                    }
                    tbody={
                      <>
                        {filteredSiteList.length ? (
                          filteredSiteList.map((i) => {
                            return (
                              <tr className={i.active ? 'active' : undefined} key={i.value} onClick={() => onChangeSite(i.value)}>
                                <td dangerouslySetInnerHTML={{ __html: i.text.replace('.', '<br>') }}></td>
                                <td>{i.ownerCompany}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td rowSpan={2} style={{ height: '100%', color: '#0076FF', fontSize: 14, background: 'none', padding: '30px 0', borderBottom: 0, fontWeight: 500, fontFamily: 'Pretendard' }}>
                              일치하는 사업장이 없습니다.
                            </td>
                          </tr>
                        )}
                      </>
                    }
                  />
                ) : null}
              </TableListStyle.Cont>
            </TableStyle.Wrap>
          </DashboardStyle.DescArea>

          <LoginStyle.Hr />
          <LoginStyle.Button type={'button'} onClick={onMoveDashboard} style={{ zIndex: 1, width: 512, margin: 0 }}>
            {t('사업장선택')}
          </LoginStyle.Button>
        </LoginStyle.Wrap>
      ) : null}
    </>
  );
};

export default VnSso;
